import "./App.css";

const Nav = () => (
  <>
    <div className="nav">
      <ul className="nav-list-items">
        <li>
          <a href="#music">music</a>
        </li>
        <li>
          <a href="#info">info</a>
        </li>
        <li>
          <a href="#contact">contact</a>
        </li>
      </ul>
    </div>
  </>
);

export default Nav;
